import Spinner from '../atoms/Spinner';

// PR-UX-04 4-states · loading.
// PR-UX-10 Doherty · skeleton must appear within 100ms (caller renders this immediately).
interface LoadingStateProps {
  label?: string;
  variant?: 'spinner' | 'skeleton';
  rows?: number;
  className?: string;
}

export default function LoadingState({
  label,
  variant = 'spinner',
  rows = 3,
  className = '',
}: LoadingStateProps) {
  if (variant === 'skeleton') {
    return (
      <ul className={`space-y-3 ${className}`} aria-busy aria-live="polite">
        {Array.from({ length: rows }).map((_, i) => (
          <li key={i} className="card animate-pulse h-20" />
        ))}
        {label && <span className="sr-only">{label}</span>}
      </ul>
    );
  }
  return (
    <div className={`flex items-center justify-center gap-3 py-12 ${className}`} aria-busy aria-live="polite">
      <Spinner size={20} />
      {label && <span className="text-base text-ink-2">{label}</span>}
    </div>
  );
}
